export default __webpack_public_path__ + "static/media/round-action-account-circle-black.bb824d04.svg";